// extracted by mini-css-extract-plugin
module.exports = {"btn__print":"CashierPrint_btn__print__1Kaja"};